import React from "react"
import { graphql } from "gatsby"
import Header from "../components/header"
import rehypeReact from "rehype-react"
import {H3,H4,P} from "../components/hx"
import Youtube from "../components/youtube"
import "../styles/youtube-embed.css"
import "../styles/image-caption.css"
import "../styles/blog-post-generic.css"

export default function BlogPost({ data }) {
  const renderAst = new rehypeReact({
    createElement: React.createElement,
    components: {
      "youtube": Youtube, 
      h3: H3,
      h4: H4,
      p: P
    },
  }).Compiler

  const post = data.markdownRemark
  return (
    <div>
      <Header />
      <div className="columns is-centered is-mobile">
        <div className="column is-7">
          <h1 className="title my-4">{post.frontmatter.title}</h1>
          <h2 className="subtitle my-4">{post.frontmatter.date}</h2>
          {
            renderAst(post.htmlAst)
          }
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      htmlAst
      headings{ 
        value
      }
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
      }
      internal {
        content
      }
    }
  }
`